import React, { Component } from "react";
import PropTypes from "prop-types";
import ProgressBar from "./progressbar";

class ProgressBarComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div className="container progressbar-inner">
        <ProgressBar fullWidth={this.props.fullWidth} />
      </div>
    );
  }
}

ProgressBarComponent.propTypes = {
  fullWidth: PropTypes.bool
};

export default ProgressBarComponent;
